import { withLayout } from '../../layout';

import ProfilePage from './profile.page';

export default withLayout(ProfilePage);
